export const SVG_GRADIENT_SELECTOR = "linearGradient, radialGradient";
export const SVG_NS = "http://www.w3.org/2000/svg";
export type SvgGradientStop = {offset: number; color: string; opacity: number};

/** Write stops without changing gradient geometry, references or other children. */
export function writeSvgGradientStops(gradient: Element, stops: SvgGradientStop[]) {
  const document = gradient.ownerDocument;
  for (const child of Array.from(gradient.children)) {
    if (child.localName === "stop") child.remove();
  }
  for (const {offset, color, opacity} of [...stops].sort((a, b) => a.offset - b.offset)) {
    const stop = document.createElementNS(SVG_NS, "stop");
    stop.setAttribute("offset", `${offset}%`);
    stop.setAttribute("stop-color", color);
    stop.setAttribute("stop-opacity", String(opacity));
    gradient.appendChild(stop);
  }
}

/** Read authored values. Inline style takes precedence over attributes. */
export function readSvgGradientStops(gradient: Element): SvgGradientStop[] {
  return Array.from(gradient.children).filter((child) => child.localName === "stop").map((stop) => {
    const property = (name: string) => (stop as SVGStopElement).style.getPropertyValue(name).trim() || stop.getAttribute(name)?.trim() || null;
    const rawOffset = stop.getAttribute("offset")?.trim() ?? null;
    const offset = rawOffset === null ? 0 : Number.parseFloat(rawOffset);
    const rawOpacity = property("stop-opacity");
    const opacity = rawOpacity === null ? 1 : Number.parseFloat(rawOpacity) / (rawOpacity.endsWith("%") ? 100 : 1);
    if (!Number.isFinite(offset) || !Number.isFinite(opacity)) throw new Error("Invalid SVG gradient stop");
    return {offset: Math.max(0, Math.min(100, offset * (rawOffset?.endsWith("%") ? 1 : 100))),
      color: property("stop-color") || "#000000", opacity: Math.max(0, Math.min(1, opacity))};
  });
}
